/* Snocks-Style Quantity Breaks v4 */
/* Liest Prozent-Wert aus Metafield (data-discount-percent) und zeigt "Spare X%" + €-Sparbetrag */

(function() {
  'use strict';

  function init() {
    const containers = document.querySelectorAll('quantity-breaks');
    containers.forEach(setupContainer);
  }

  function setupContainer(container) {
    if (container.dataset.snocksInit === 'true') return;
    container.dataset.snocksInit = 'true';

    const breaksContainer = container.querySelector('.quantity-breaks-container');
    if (!breaksContainer) return;

    const discountPercent = parseFloat(container.dataset.discountPercent) || 0;
    const basePrice = parseFloat(container.dataset.basePrice) || 0;

    const radios = breaksContainer.querySelectorAll('input[type="radio"]');
    if (!radios.length) return;

    // Header bauen: "Menge: X"
    const header = document.createElement('div');
    header.className = 'snocks-header';
    
    const mengeSpan = document.createElement('span');
    mengeSpan.className = 'snocks-header__menge';
    mengeSpan.innerHTML = 'Menge: <strong>1</strong>';
    header.appendChild(mengeSpan);

    // Tooltips-Wrapper
    const tooltipsWrapper = document.createElement('div');
    tooltipsWrapper.className = 'snocks-tooltips';
    tooltipsWrapper.style.cssText = 'position:absolute; left:0; right:0; bottom:100%; height:0;';
    header.appendChild(tooltipsWrapper);

    breaksContainer.parentNode.insertBefore(header, breaksContainer);

    // Fortschrittsbalken
    const progress = document.createElement('div');
    progress.className = 'snocks-progress';
    const progressBar = document.createElement('div');
    progressBar.className = 'snocks-progress__bar';
    progressBar.style.width = '0%';
    progress.appendChild(progressBar);
    breaksContainer.parentNode.insertBefore(progress, breaksContainer);

    // "Spare X%" in jede Pill (außer 1. Pill)
    const labels = breaksContainer.querySelectorAll('label.quantity-break');
    labels.forEach((label, index) => {
      const captionEl = label.querySelector('.quantity-break__caption');
      if (!captionEl) return;

      if (index === 0) {
        captionEl.textContent = '';
        captionEl.style.display = 'none';
        return;
      }

      if (discountPercent > 0) {
        captionEl.textContent = 'Spare ' + discountPercent + '%';
      }
    });

    // Tooltips über Pills (Sparbetrag in €)
    labels.forEach((label, index) => {
      const tooltip = document.createElement('div');
      tooltip.className = 'snocks-tooltip';
      tooltip.dataset.pillIndex = index;
      
      const totalLabels = labels.length;
      const percentLeft = ((index + 0.5) / totalLabels) * 100;
      tooltip.style.left = percentLeft + '%';

      if (index === 0) {
        tooltip.style.display = 'none';
      } else {
        const radio = radios[index];
        if (radio) {
          const qty = parseInt(radio.value, 10) || (index + 1);
const savedAmount = (basePrice * qty * discountPercent / 100) / 100;
          tooltip.textContent = 'Spare €' + savedAmount.toFixed(2).replace('.', ',');
        }
      }

      tooltipsWrapper.appendChild(tooltip);
    });

    // Auf Radio-Änderungen hören
    radios.forEach((radio, idx) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        updateUI(idx, radios, header, progressBar, tooltipsWrapper);
      });
    });

    // Initial-State
    const checkedIdx = Array.from(radios).findIndex(r => r.checked);
    if (checkedIdx >= 0) {
      updateUI(checkedIdx, radios, header, progressBar, tooltipsWrapper);
    } else {
      updateUI(0, radios, header, progressBar, tooltipsWrapper);
    }
  }

  function updateUI(activeIdx, radios, header, progressBar, tooltipsWrapper) {
    const total = radios.length;
    const radio = radios[activeIdx];
    const qty = radio ? (parseInt(radio.value, 10) || (activeIdx + 1)) : 1;

    const mengeStrong = header.querySelector('.snocks-header__menge strong');
    if (mengeStrong) mengeStrong.textContent = qty;

    const progressPercent = ((activeIdx + 1) / total) * 100;
    progressBar.style.width = progressPercent + '%';

    const tooltips = tooltipsWrapper.querySelectorAll('.snocks-tooltip');
    tooltips.forEach((tt, i) => {
      if (i === activeIdx) {
        tt.classList.add('snocks-tooltip--active');
      } else {
        tt.classList.remove('snocks-tooltip--active');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();